/**
 * Created by mauget on 1/14/16.
 */

import $ from 'jquery';

import listService from 'ListService.js';
import undoService from 'UndoService.js';
import pageSyncService from 'PageSyncService.js';
import constants from 'Constants.js';
import textConstants from 'TextConstants.js';
import util from 'util/Util.js';
import focusController from 'FocusController.js';

import BaseController from 'BaseController.js';
import _ from 'lodash';

const handles = `${constants.BORDER_TOP_CLASS}, ${constants.BORDER_LEFT_CLASS},
            ${constants.BORDER_RIGHT_CLASS}, ${constants.BORDER_BOTTOM_CLASS}`;

//==========================================================================================
// This singleton controller handles resizing a control by dragging its borders.
//==========================================================================================
class ResizeController extends BaseController {


    constructor() {
        super();
        this._hash = {
            'size-handle-top': 'T',
            'size-handle-bottom': 'B',
            'size-handle-left': 'L',
            'size-handle-right': 'R'
        };
    }


    // Differentiate events: prevent collisions with handler on/off for given event in other modules.
    static get namespace() { return '.nameSpaceResizeController'; }


    //==========================================================================================
    // Property: map css class name to top, bottom, left, or right border div.
    //==========================================================================================
    get hash() {
        return this._hash;
    }

    //==========================================================================================
    // Dynamically resizes a control on the page.
    //
    // Param className is a border handle div class name
    //
    // Param lag is a parameter packet. Pass one like this one ...
    //
    //    const lag  = {
    //        top:  util.extractNum( model.get( 'top' ) ),
    //        left: util.extractNum( model.get( 'left' ) ),
    //        width:  util.extractNum( model.get( 'width' ) ),
    //        height: util.extractNum( model.get( 'height' ) ),
    //        x: pageX,  // mouse offset by PF page x
    //        y: pageY   // mouse offset by PF page y
    //    };
    //
    // Params x, y are the current border handle drap postion relative to the page.
    //==========================================================================================
    resize(className, lag, model, x, y, undoEvent) {
 
      

        let minWidth = util.extractNum(model.get('minWidth'));
        let minHeight = util.extractNum(model.get('minHeight'));
        let control = listService.getObject(model.get('id'));
        let finalWidth;
        let finalHeight;

        // PF-2665: abort resize if the control is not selected && is not a group
        if ( !(listService.isSelected(model.get('id'))) && !(control.model.get('isGroupContainer')) ) {
            return;
        }

        if (!minWidth){
            minWidth = constants.CONTROL_MIN_WIDTH;
        }

        if (!minHeight){
            minHeight = constants.CONTROL_MIN_HEIGHT;
        }

        // PF-1869 Turning off this event so the resized action can be tracked for undo/redo.
        //model.set({ undoEvent: undoEvent }, { silent: true });
        const currentControl = $('#' + model.get('id'));
        const controlCore = $('#' + model.get('id') + ' > .pf-control-core');
        const isGroup = constants.GROUP_KEYS.includes(model.get('factoryKey'));
        switch (this.hash[className]) {
            case 'T':
                const dt = lag.y - y;
                finalHeight = dt + lag.height;
                if (finalHeight < minHeight) {
                    finalHeight = minHeight;
                    model.set({ 'height': Math.round(finalHeight) }, { silent: true });
                    if (isGroup) {
                        currentControl.height(model.get('height'));
                        controlCore.height(model.get('height'));
                    }
                }else{
                    model.set({ 'height':  Math.round(finalHeight), 'top': y }, { silent: true });
                    if (isGroup) {
                        currentControl.height(model.get('height'));
                        currentControl.css('top', y);

                        controlCore.height(model.get('height'));
                    }
                }
                break;
            case 'L':
                const dl = lag.x - x;
                finalWidth = dl + lag.width;
                if (finalWidth < minWidth) {
                    finalWidth = minWidth;
                    model.set({ 'width':  Math.round(finalWidth) }, { silent: true });
                    if (isGroup) {
                        currentControl.width(model.get('width'));
                        controlCore.width(model.get('width'));
                    }
                }else{
                    model.set({ 'width':  Math.round(finalWidth), 'left': x }, { silent: true });

                    if (isGroup) {
                        currentControl.width(model.get('width'));
                        currentControl.css('left', x);
                        controlCore.width(model.get('width'));
                    }
                }
                break;
            case 'B':
                const db = y - lag.y;
                finalHeight = db + lag.height;
                if (finalHeight < minHeight) {
                    finalHeight = minHeight;
                }

                model.set('height',  Math.round(finalHeight), { silent: true });

                if (isGroup) {
                    currentControl.height(model.get('height'));
                    controlCore.height(model.get('height'));
                }

                break;
            case 'R':
                const dr = x - lag.x;
                finalWidth = dr + lag.width;
                if (finalWidth < minWidth) {
                    finalWidth = minWidth;
                }
                model.set('width',  Math.round(finalWidth), { silent: true });

                if (isGroup) {
                    currentControl.width(model.get('width'));
                    controlCore.width(model.get('width'));
                }

                break;
        }

        if (!isGroup) {
            control.render();
        }
    }


    //==========================================================================================
    // Builds a parameter packet containing the current control dimenions along with the
    // translated mouse (x, y) offset within the PF fpage, accounting for scroll.
    //==========================================================================================
    createParamPacket(ev, model) {

        const { pageX, pageY } = ev.originalEvent;
        let view = listService.getObject(model.get('id'));
        let retY;
        let retX
        if(view._groupId){
            let groupView = listService.getObject(view._groupId);
            let groupTop = util.extractNum(groupView.model.get('top'));
            let groupLeft = util.extractNum(groupView.model.get('left'));
            retY =  pageY - $(window).scrollTop() - util.pagePos.top-groupTop;
            retX = pageX - $(window).scrollLeft() - util.pagePos.left-groupLeft;
        }
        else{
           retY =  pageY - $(window).scrollTop() - util.pagePos.top;
           retX = pageX - $(window).scrollLeft() - util.pagePos.left;
        }

        return {
            top: util.extractNum(model.get('top')),
            left: util.extractNum(model.get('left')),

            width: util.extractNum(model.get('width')),
            height: util.extractNum(model.get('height')),

            // Current mouse position on PF page, accounting for scrolling
            x: retX < 0 ? 1 : retX,
            y: retY < 0 ? 1 : retY
        };
    }

    unlistenForResizeRequest() {
        try {
            const $handles = $(handles);
            $handles.off(constants.EV_MOUSEDOWN + namespace);
        }
        catch (ex) { }

        try {
            $page.off(constants.EV_MOUSEMOVE + namespace);
        }
        catch (ex) { }

        try {
            $(constants.BODY).off(constants.EV_MOUSEUP + namespace);
        }
        catch (ex) { }
    }

    //==========================================================================================
    // Invoke this method to listen for border-drag mouse actions.
    // TODO Delegation: INSTANCE_CLASS delegate must exist, but no controls need yet be present.
    // TODO DELEGATE to #layout-frame.
    //==========================================================================================
    listenForResizeRequest(id) {

        const namespace = ResizeController.namespace;

        const $handles = id ?  $("#" + id + ' [class^="size-handle"]') : $(handles);
        //=====================================================================
        // 1. Listen for 'mousedown' on a control resize border
        //=====================================================================
        $handles.off(constants.EV_MOUSEDOWN + namespace, null);

        $handles.on(constants.EV_MOUSEDOWN + namespace, null, this.handleMouseDown.bind(this));
    }

    handleMouseDown(ev) {
        ev.preventDefault();

        const namespace = ResizeController.namespace;
        // Identify the border that heard the mousedown event
        const className = ev.currentTarget.className;

        // Find control; model for it
        const controlId = ev.currentTarget.parentElement.id;
        const control = listService.objectList.get(controlId);
        const model = control.model;

        // Lagging / current position / dimension parameter packet
        const lag = this.createParamPacket(ev, model);

        // To originate control position relative (0,0) of this PF page:
       // const $page = $(constants.PAGESEL_ID);
        let $page = $(constants.PAGESEL_ID);
        if (control && control.groupId) {
            $page = $('#' + control.groupId);
        }

        //PF-2456 - Resize event is not releasing always
        listService.isResizing = true;


        if (!listService.groupItemHTML && $('#groupItems' + model.id)) {
            listService.groupItemHTML = $('#groupItems' + model.id).html();
        }

        if (!listService.layoutControlHTML && model.get('factoryKey') === "control_table") {
            listService.layoutControlHTML = $('#' + controlId).html();
        }

        //=====================================================================
        // 2. We heard mousdedown, so listen for mouse move over entire PF page
        // until mouse up
        //=====================================================================
        $page.on(constants.EV_MOUSEMOVE + namespace, null, lag, ev => {
            ev.preventDefault();

            const lagPos = ev.data;
            let view = listService.getObject(model.get('id'));
            let retY;
            let retX;
            if (view && view._groupId) {
              let groupView = listService.getObject(view._groupId);
              let groupTop = util.extractNum(groupView.model.get('top'));
              let groupLeft = util.extractNum(groupView.model.get('left'));
              retY =  ev.originalEvent.pageY - util.pagePos.top - $(window).scrollTop()-groupTop;
              retX = ev.originalEvent.pageX - util.pagePos.left - $(window).scrollLeft()-groupLeft;
              
              if (retY < 0){
                 retY = 1;
              }else if(retY > util.extractNum(groupView.model.get('height')) ){
                 retY = util.extractNum(groupView.model.get('height'));
              }
               
              if (retX < 0){
                 retX = 1;
              }else if(retX > util.extractNum(groupView.model.get('width')) ){
                 retX = util.extractNum(groupView.model.get('width'));
              }
              
            }
            else{
              retY =  ev.originalEvent.pageY - util.pagePos.top - $(window).scrollTop();
              retX = ev.originalEvent.pageX - util.pagePos.left - $(window).scrollLeft();
            }

          // PF-1869 Memoizing the current size before the mouse movement begins
            if(!view.model.get('originalSize')){
                let originalSize={
                  originalX: view.model.get('left'),
                  originalY: view.model.get('top'),
                  originalHeight:view.model.get('height'),
                  originalWidth:view.model.get('width')
                };
                view.model.set('originalSize',originalSize,{silent:true})
            }

            this.resize(className, lagPos, model,
                retX,
                retY,
                '');

            // Redraw selection rectangle
            focusController.selectionRectangle(controlId);
            focusController.switchTab(constants.SETTINGS_TAB);
        });

        //=====================================================================
        // 3. We heard mouseup during mousemove, so stop listening for mousemove
        // anywhere in BODY, (using OUR SPECIFIC NAMESPACE ONLY)
        //=====================================================================
        $(constants.BODY).on(constants.EV_MOUSEUP + namespace, null, ev => {
            ev.preventDefault();
            console.log('MOUSE UP');



            // TODO - UNDO - Need to track the RESIZE UNDO specifically here. Need to provide the Starting Position/Size before (Drag-Resize) started.
            // Probably a custom Undo Method in the UndoService that handles this case

            /*
            model.set({ undoEvent: 'resize' });

            switch( this.hash[className] ) {

                case 'T':
                    model.set({ 'height': model.get('height') -1}, {silent:true});
                    //model.set({ 'height': model.get('height') +1, 'top': model.get('top') });
                    break;

                case 'L':
                    model.set({ 'width': model.get('width') -1}, {silent:true});
                   // model.set({ 'width': model.get('width') +1, 'left':  model.get('left') });
                    break;

                case 'B':
                    model.set({ 'height': model.get('height') -1}, {silent:true});
                    //model.set( 'height', model.get('height') +1 );
                    break;

                case 'R':
                    model.set({ 'width': model.get('width') -1}, {silent:true});
                    //model.set( 'width',  model.get('width')  +1);
                    break;

            }

            */
          let view = listService.getObject(model.get('id'));
          let currentSize={
              currentX:view.model.get('left'),
              currentY:view.model.get('top'),
              currentHeight:view.model.get('height'),
              currentWidth:view.model.get('width')
          };
          let originalSize=Object.assign({},view.model.get('originalSize'));
          view.model.set('originalSize',null,{silent:true});
          
          if( !_.isEmpty(originalSize)  ){
            undoService.add({
                undo:() => {
                view.model.set({left: originalSize.originalX, top: originalSize.originalY, width: originalSize.originalWidth, height: originalSize.originalHeight},{silent:true});
                view.render()
                },
                redo: () => {
                view.model.set({left: currentSize.currentX, top: currentSize.currentY, width: currentSize.currentWidth, height: currentSize.currentHeight},{silent:true});
                view.render()
                }
            },textConstants.UNDO_RESIZE);
          }
          // PF-1869 Removed trigger in order to track the resize action for Undo/Redo
            //model.trigger('change');
            view.render();

            //view.checkLastColumnResize();

            listService.isResizing = false;
            $(constants.BODY).off(constants.EV_MOUSEUP + namespace);
            $page.off(constants.EV_MOUSEMOVE + namespace);
        });

        return false;
    }

    getValidWidth(model, width) {
        let validWidth = width;
        let leftPos = parseInt(util.extractNum(model.get('left')));
        let parentWidth = listService.currentForm.model.get('formWidth');

        //Check if the elemnt is inside of a group to set group's edge
        let grpId = listService.getGroupObject(model.get('id'));
        if( grpId !== '' ){
            let grp = listService.getObject(grpId);
            parentWidth =  parseInt(util.extractNum(grp.model.get('width')));
        }

        let minWidth = util.extractNum(model.get('minWidth'));
        if (!minWidth) {
            minWidth = constants.CONTROL_MIN_WIDTH;
        }

        if (listService.selectedCount === 1) {
            let view = listService.getObject(model.get('id'));
            if(view._groupId){
                let groupView = listService.getObject(view._groupId);
                parentWidth =  util.extractNum(groupView.model.get('width'));
            }
        }

        validWidth  = this.validSize(width, minWidth, parentWidth, leftPos);

        return Math.round(validWidth);
    }

    getValidHeight(model, height) {
        let validHeight = height;
        let topPos = parseInt(util.extractNum(model.get('top')));
        let parentHeight = listService.currentForm.model.get('formHeight');

        //Check if the elemnt is inside of a group to set group's edge
        let grpId = listService.getGroupObject(model.get('id'));
        if( grpId !== '' ){
            let grp = listService.getObject(grpId);
            parentHeight =  parseInt(util.extractNum(grp.model.get('height')));
        }

        let minHeight = util.extractNum(model.get('minHeight')); 
        if (!minHeight) {
            minHeight = constants.CONTROL_MIN_HEIGHT;
        }  

        if (listService.selectedCount === 1) {
            let view = listService.getObject(model.get('id'));
            if(view._groupId){
               let groupView = listService.getObject(view._groupId);
               parentHeight = util.extractNum(groupView.model.get('height'));
            }
        }

        validHeight  = this.validSize(height, minHeight, parentHeight, topPos);

        return Math.round(validHeight);
    }

    validSize(size, minSize, parentSize, pos){
        let validSize = size;
        if (size < minSize) {
            validSize = minSize;
        } else {
            let remainingSpace = Number(parentSize - pos);
            if (remainingSpace > 0 && size > remainingSpace) {
                validSize = remainingSpace;
            }
        }
        return validSize;
    }
}

const resizeController = new ResizeController();
export default resizeController;
